import axiosInstance from "./axiosInstance";
import {LoginUserProps} from "../types/types";

const loginUser = async (formData: LoginUserProps) => {
  try {
    const {data} = await axiosInstance.post("/login", formData);
    return data;
  } catch (error: any) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message);
    }
    throw new Error("Error creating user");
  }
};

export default loginUser;
